/**
 * AlertsList — panel showing active alerts with severity icons.
 */

import './AlertsList.css';

export type AlertSeverity = 'critical' | 'warning' | 'info' | 'ok';

export interface AlertItem {
  id: string;
  severity: AlertSeverity;
  title: string;
  source: string;
  timestamp: string;
}

interface AlertsListProps {
  alerts?: AlertItem[];
  onAlertClick?: (alert: AlertItem) => void;
}

const MOCK_ALERTS: AlertItem[] = [
  { id: 'a1', severity: 'critical', title: 'Open Circuit',    source: 'STR-07', timestamp: '09:45' },
  { id: 'a2', severity: 'warning',  title: 'Temp High',       source: 'INV-03', timestamp: '14:22' },
  { id: 'a3', severity: 'warning',  title: 'Low Output',      source: 'INV-01', timestamp: '08:10' },
];

function SeverityDot({ severity }: { severity: AlertSeverity }) {
  return <span className={`alert-dot alert-dot--${severity}`} aria-hidden="true" />;
}

export default function AlertsList({ alerts = MOCK_ALERTS, onAlertClick }: AlertsListProps) {
  return (
    <div className="alerts-card card">
      {/* Header */}
      <div className="alerts-card__header">
        <span className="alerts-card__title">
          Alerts
          {alerts.length > 0 && (
            <span className="alerts-card__count">{alerts.length}</span>
          )}
        </span>
        <button className="alerts-card__viewall" type="button">
          View all
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 4l4 4-4 4"/>
          </svg>
        </button>
      </div>

      {/* List */}
      {alerts.length === 0 ? (
        <div className="alerts-empty">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--green)" strokeWidth="1.8">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          <span>No active alerts</span>
        </div>
      ) : (
        <ul className="alerts-list" role="list">
          {alerts.map((alert) => (
            <li key={alert.id} className="alert-item" role="listitem">
              <button
                type="button"
                className="alert-item__btn"
                onClick={() => onAlertClick?.(alert)}
              >
                <SeverityDot severity={alert.severity} />
                <div className="alert-item__body">
                  <div className="alert-item__source">{alert.source}</div>
                  <div className="alert-item__title">{alert.title}</div>
                </div>
                <div className="alert-item__right">
                  <span className="alert-item__time">{alert.timestamp}</span>
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" className="alert-item__chevron">
                    <path d="M6 4l4 4-4 4"/>
                  </svg>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
